import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label, Input
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { accessRole } from '../../../../helpers/access_role'
import Select from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import IndexBloc from '../Index/Blocs/IndexBloc'
import Shimmer from "react-shimmer-effect";

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
if(accessRole('approve')){
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
}

const satuanWaktu = [
    { value: 'Hari', label: 'Hari'},
    { value: 'Minggu', label: 'Minggu'},
    { value: 'Bulan', label: 'Bulan' },
]

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};



class DetailView extends Component {

    source
    indexBloc = new IndexBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            detail: null,
            typeOption: [],
            signatoriesOption: [],
            typeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'paid_leave_type_id',
                    order: 'asc' 
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc' 
                }
            } 
        }
    }

    loadSignatoriesList = async () => {
        let offset = (this.state.signatoriesFilter.page_number-1)*this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSignatoriesList(query, this.source.token)
    }

    loadTypeList = async () => {
        let offset = (this.state.typeFilter.page_number-1)*this.state.typeFilter.page_size
        const query = {
            search: this.state.typeFilter.filter_value,
            limit: this.state.typeFilter.page_size,
            offset: offset,
            order: this.state.typeFilter.sort_order.column,
            sort: this.state.typeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchTypeList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = { 
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadTypeList()
        this.loadSignatoriesList()
        this.loadDetail()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.signatoriesFilter.filter_value = value

        this.timer = setTimeout(() => this.loadSignatoriesList(), 800);
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ typeOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount = () => {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.typeChannel?.unsubscribe()
        this.indexBloc.signatoriesChannel?.unsubscribe()
    }

    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <PegawaiSideBar active="cuti" />
                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?cuti`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Detail Pengajuan Cuti</CardTitle>
                                    <CardSubtitle className="mb-3">
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                    >

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jenis Cuti
                                            </Label>
                                            { detail ? 
                                                <Col md="4">
                                                    <Input
                                                        value={detail?.paid_leave_type_name}
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                :
                                                <Shimmer>
                                                    <Label className="col-md-4 col-form-label"></Label>
                                                </Shimmer>
                                            }
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alasan Cuti
                                            </Label>
                                            { detail ? 
                                                <Col md="4">
                                                    <Input
                                                        value={detail?.paid_leave_reason}
                                                        readOnly={true}
                                                        type="textarea"
                                                    />
                                                </Col>
                                                :
                                                <Shimmer>
                                                    <Label className="col-md-4 col-form-label"></Label>
                                                </Shimmer>
                                            }
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai Cuti
                                            </Label>
                                            { detail ? 
                                                <Col md="4">
                                                    <Input
                                                        value={reformatDate(detail?.paid_leave_start_date, true)}
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                :
                                                <Shimmer>
                                                    <Label className="col-md-4 col-form-label"></Label>
                                                </Shimmer>
                                            }
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai Cuti 
                                            </Label>
                                            { detail ? 
                                                <Col md="4">
                                                    <Input
                                                        value={reformatDate(detail?.paid_leave_end_date, true)}
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                :
                                                <Shimmer>
                                                    <Label className="col-md-4 col-form-label"></Label>
                                                </Shimmer>
                                            }
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alamat Selama Menjalankan Cuti
                                            </Label>
                                            { detail ? 
                                                <Col md="4">
                                                    <Input
                                                        value={detail?.paid_leave_address}
                                                        readOnly={true}
                                                        type="textarea"
                                                    />
                                                </Col>
                                                :
                                                <Shimmer>
                                                    <Label className="col-md-4 col-form-label"></Label>
                                                </Shimmer>
                                            }
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No Telepon Selama Cuti
                                            </Label>
                                            { detail ? 
                                                <Col md="4">
                                                    <Input
                                                        value={detail?.paid_leave_phone}
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                :
                                                <Shimmer>
                                                    <Label className="col-md-4 col-form-label"></Label>
                                                </Shimmer>
                                            }
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Atasan 
                                            </Label>
                                            { detail ? 
                                                <Col md="9">
                                                    <Input
                                                        value={detail?.paid_leave_signatories_official}
                                                        readOnly={true}
                                                    />
                                                </Col>
                                                :
                                                <Shimmer>
                                                    <Label className="col-md-4 col-form-label"></Label>
                                                </Shimmer>
                                            }
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }

}

export default DetailView 